<section class="gf" *ngIf="guide as g" [class.gf--home]="placement === 'home'">
  <div class="gf-inner">
    <a class="gf-cover" [routerLink]="path(g.slug)" tabindex="-1" aria-hidden="true">
      <img [src]="g.coverUrl" alt="" width="200" height="283" loading="lazy" />
    </a>
    <div class="gf-body">
      <p class="gf-eyebrow">
        {{ placement === 'home' ? 'New from PlateX Market Guides' : 'Market Guides' }}<span *ngIf="g.issueLabel"> · {{ g.issueLabel }}</span>
      </p>
      <h2 class="gf-title"><a [routerLink]="path(g.slug)">{{ g.title }}</a></h2>
      <p class="gf-sub">{{ g.subtitle }}</p>
      <p class="gf-standfirst" *ngIf="g.landing?.standfirst">{{ g.landing.standfirst }}</p>
      <p class="gf-links">
        <a class="gf-cta" [routerLink]="path(g.slug)">{{ cta }} <span aria-hidden="true">→</span></a>
        <a class="gf-all" *ngIf="placement === 'insights'" routerLink="/market-guides">All Market Guides</a>
      </p>
    </div>
  </div>
</section>
